<div class="customer-search-container">
  <!-- Header Section -->
  <div class="search-header">
    <div class="header-content">
      <h1 class="page-title">Customer Search</h1>
      <p class="page-subtitle">Search for customers by name or phone number</p>
    </div>
  </div>

  <!-- Search Input Section -->
  <div class="search-section">
    <div class="search-input-wrapper">
      <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
      <input #searchInput type="text" class="search-input" placeholder="Search by customer name or phone number..."
        [(ngModel)]="searchTerm" (input)="onSearchChange($event.target.value)" [disabled]="isLoading" />
      <div class="search-loader" *ngIf="isLoading">
        <div class="spinner"></div>
      </div>
    </div>
    <p class="search-hint">Enter at least 2 characters to search</p>
  </div>

  <!-- Error Message -->
  <div class="error-message" *ngIf="errorMessage">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <span>{{ errorMessage }}</span>
  </div>

  <!-- Results Section -->
  <div class="results-section" *ngIf="hasSearched">
    <!-- Results Count -->
    <div class="results-header" *ngIf="!isLoading || customers.length > 0">
      <p class="results-count">
        <span class="count-number">{{ totalCount }}</span>
        <span class="count-text">{{ totalCount === 1 ? 'customer' : 'customers' }} found</span>
      </p>
    </div>

    <!-- Customer List -->
    <div class="customer-list" *ngIf="customers.length > 0">
      <div class="customer-card" *ngFor="let customer of customers" (click)="onCustomerClick(customer)" role="button"
        tabindex="0" (keydown.enter)="onCustomerClick(customer)" (keydown.space)="onCustomerClick(customer)">
        <div class="customer-avatar">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <div class="customer-info">
          <h3 class="customer-name">{{ customer.name }}</h3>
          <p class="customer-phone">{{ customer.phoneNumber }}</p>
        </div>
        <div class="customer-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </div>

    <!-- No Results -->
    <div class="no-results" *ngIf="customers.length === 0 && !isLoading && hasSearched">
      <div class="no-results-icon">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <h3 class="no-results-title">No customers found</h3>
      <p class="no-results-text">Try adjusting your search terms</p>
    </div>

    <!-- Load More Button -->
    <div class="load-more-section" *ngIf="hasMoreResults && !isLoading">
      <button class="btn-load-more" (click)="loadMore()">
        Load More
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
    </div>

    <!-- Loading Indicator -->
    <div class="loading-section" *ngIf="isLoading && customers.length === 0">
      <div class="loading-spinner"></div>
      <p class="loading-text">Searching customers...</p>
    </div>
  </div>

  <!-- Empty State (Before Search) -->
  <div class="empty-state" *ngIf="!hasSearched && !isLoading">
    <div class="empty-state-icon">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    </div>
    <h3 class="empty-state-title">Start Searching</h3>
    <p class="empty-state-text">Enter a customer name or phone number to begin</p>
  </div>
</div>